import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import Config from './config';
import Sentry from './helpers/sentry.helper';

if (!Config.DEBUG && Config.SENTRY_URL) {
    Sentry.init({dsn: Config.SENTRY_URL});
}

createRoot(document.getElementById('root')).render(<App />);
